import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Route } from 'react-router';

import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { Loader } from '../../components';
import { DOMAIN_ZELFHULP_BEGELEID, DOMAIN_ZELFHULP_NAASTEN } from '../../config/constants';
import getCurrentDomain from '../../helpers/getCurrentDomain';
import useTypedDispatch from '../../hooks/useTypedDispatch';
import { fetchClients } from '../../store/actions/NursePractitioner';
import { setCurrentDomain } from '../../store/actions/UI';
import Entity from '../Entity';
import Router from './Router';

// Config.
import routesConfigGuidedSelfHelp from './config/guidedSelfHelp';
import routesConfigSelfHelp from './config/selfHelp';
import routesConfigSelfHelpCloseOnes from './config/selfHelpCloseOnes';

const routesConfig = (currentDomain: string) => {
  switch (currentDomain) {
    case DOMAIN_ZELFHULP_BEGELEID: {
      return routesConfigGuidedSelfHelp;
    }

    case DOMAIN_ZELFHULP_NAASTEN: {
      return routesConfigSelfHelpCloseOnes;
    }

    default: {
      return routesConfigSelfHelp;
    }
  }
};

const Routes = () => {
  const dispatch = useTypedDispatch();
  const { t } = useTranslation();

  const currentDomain = useSelector<ImmutableRootState<string>, string>(
    (state) => state.getIn(['uiInternal', 'currentDomain', 'raw'], ''),
  );

  useEffect(() => {
    const domain = getCurrentDomain();

    dispatch(setCurrentDomain({
      raw: domain,
      pretty: t(`domains:${domain}`),
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.hostname]);

  useEffect(() => {
    if (currentDomain === DOMAIN_ZELFHULP_BEGELEID) {
      const dispatchFetchClients = async () => {
        await dispatch(fetchClients());
      };

      dispatchFetchClients().catch(() => {});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDomain]);

  if (currentDomain !== null) {
    return (
      <Router config={routesConfig(currentDomain)}>
        <Route>
          <Entity />
        </Route>
      </Router>
    );
  }

  return <Loader />;
};

export default Routes;
